<template>
    <v-app id="inspire">
        <v-navigation-drawer
                app
                clipped
                v-model="drawer"
        >
            <v-subheader class="mt-4 grey--text text--darken-1">Operações</v-subheader>
            <v-list dense>
                <v-list-item link>
                    <v-list-item-action>
                        <v-icon>mdi-file-upload-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <router-link tag="v-list-item-title" to="/carregar-lista">
                            Carregar Lista
                        </router-link>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                    <v-list-item-action>
                        <v-icon>mdi-dice-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <router-link tag="v-list-item-title" to="/">
                            Sorteio
                        </router-link>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                    <v-list-item-action>
                        <v-icon>mdi-trophy-variant-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <router-link tag="v-list-item-title" to="/sorteados">
                            Ganhadores
                        </router-link>
                    </v-list-item-content>
                </v-list-item>
              <v-list-item link>
                <v-list-item-action>
                  <v-icon>mdi-dice-multiple</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <router-link tag="v-list-item-title" to="/sorteio-especial">
                    Sorteio Especial 100k
                  </router-link>
                </v-list-item-content>
              </v-list-item>

              <v-subheader class="mt-4 grey--text text--darken-1">Últimos Sorteados</v-subheader>
                <v-list>
                    <v-list-item
                            :key="winner.number"
                            link
                            v-for="winner in this.$store.state.winners"
                    >
                        <v-list-item-avatar>
                            <img
                                    :src="winner.avatar"
                                    alt=""
                            >
                        </v-list-item-avatar>
                        <v-list-item-title v-text="winner.name"/>
                    </v-list-item>
                </v-list>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                app
                clipped-left
                color="red"
                dense
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
            <v-img :src="require('./assets/shark-icon-1.svg')" class="ma-1"
                   style="height: 32px; max-width: 32px"
            >
            </v-img>
            <v-toolbar-title class="mr-12 align-center">
                <span class="title">Tubarão Sorteador</span>
            </v-toolbar-title>
            <v-spacer/>
            <v-row align="center"
                   style="max-width: 350px"
                   v-if="this.$store.state.list"
            >
                <div class="blockquote">
                    <v-icon large>
                        mdi-account-group
                    </v-icon>
                    <span class="subtitle-1"><strong>{{this.$store.state.list.length}}</strong></span>
                    <span class="align-center"> participantes</span>
                </div>
            </v-row>
        </v-app-bar>

        <v-content>
            <v-container class="fill-height">
                <router-view/>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
	export default {
		props: {
			source: String,
		},
		data: () => ({
			drawer: null,
			items: []
		}),
		created() {
			this.$vuetify.theme.dark = true
		},
	}
</script>
